<template>
  <div>
    <vs-card>

      <b-col cols="12" style="padding-right: 20px">
        <b-row align-h="start">
          <b-col cols="3" align-self="center"
            ><b-form-input
              v-model="arananDeger"
              @keyup.enter="getStokList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col cols="12" md="auto">
            <vs-button
              style="border-radius: 5px"
              @click="getStokList()"
              type="gradient"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              >Listele</vs-button
            >
          </b-col>
        </b-row>
      </b-col>
    </vs-card>

    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 500px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowdata"
        :animateRows="true"
        :pagination="true"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
      >
    
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import ReceteDurumCellRenderer from "./CellRenderers/ReceteDurumCellRenderer.vue"
import DurumGorunumCellRenderer from "./CellRenderers/DurumGorunumCellRenderer.vue";
import MpStokRecetesiButton from "../components/uzum-components/mpstokyonetimi-components/MpStokRecetesiButton.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import ReceteStokPriceCellRenderer from "./CellRenderers/ReceteStokPriceCellRenderer.vue";
export default {
  data() {
    return {
      arananDeger: "",
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null,
      rowdata: null
    };
  },
  components: {
    ReceteDurumCellRenderer,
    AgGridVue,
    MpStokRecetesiButton,
    DurumGorunumCellRenderer,
    TextGorunumCellRenderer,
    ReceteStokPriceCellRenderer
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    this.getStokList();
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${formatted}` + sign;
      }
    },
    getStokList() {
      var vm = this;
      var vs = this.$vs;
      if(vm.arananDeger !="")
      vs.loading({
        background: "#0064fa",
        color: "danger",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      vm.veriler = [];
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        COMPANYID: state.MusteriId,
        ARANAN: vm.arananDeger,
        ISLEM: "LIST",
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.STOCK(args, function(err, result) {
          if (result.STOCKResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          setTimeout( ()=> {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }, 1000);
          vm.veriler = JSON.parse(result.STOCKResult);
          vm.rowdata = JSON.parse(vm.veriler.jsonData);
        });
      });
    }
  },
  mounted() {
    
    this.$root.$on("getStokListForRecete", () => {
      this.getStokList();
    });
   
  },
  beforeDestroy() {
    this.$root.$off("getStokListForRecete");
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "MpStokRecetesiButton"
      },
      {
        headerName: "Kod",
        children: [
          {
            width: 150,
            headerName: "Stok Kodu",
            field: "STOCKNO",
            sortable: true,
            filter: "agSetColumnFilter",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true
          },
          {
            width: 100,
            headerName: "Müşteri Stok Kodu",
            field: "CUSTOMERSTOCKNO",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            columnGroupShow: "open",
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Tedarikçi Stok Kodu",
            field: "SUPPLIERSTOCKNO",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          }
        ]
      },

      {
        headerName: "Detay",
        children: [
          {
            width: 250,
            headerName: "Stok Adı",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            field: "STOCKNAME",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Stok Adı 2",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            field: "STOCKNAME2",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Sezon",
            field: "SEASON",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Marka",
            field: "BRAND",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            headerName: "Model",
            field: "MODEL",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            headerName: "Depo",
            width: 100,
            columnGroupShow: "open",
            field: "DEPOTID",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Birim",
            field: "UNIT",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Kdv",
            columnGroupShow: "open",
            field: "VAT",
            sortable: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Orijin",
            columnGroupShow: "open",
            field: "ORIGIN",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agTextColumnFilter"
          }
        ]
      },
      {
        headerName: "Grup",
        children: [
          {
            width: 150,
            headerName: "Grup Kodu",
            field: "GROUPCODE",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Özel Kod 1",
            field: "SPECCODE1",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            headerName: "Özel Kod 2",
            width: 100,
            columnGroupShow: "open",
            field: "SPECCODE2",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            columnGroupShow: "open",
            headerName: "Özel Kod 3",
            field: "SPECCODE3",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Özel Kod 4",
            columnGroupShow: "open",
            field: "SPECCODE4",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Özel Kod 5",
            columnGroupShow: "open",
            field: "SPECCODE5",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          }
        ]
      },
      {
        headerName: "Kategori",
        children: [
          {
            width: 120,
            headerName: "Kategori 1",
            field: "CATAGORY1",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 2",
            field: "CATAGORY2",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 3",
            field: "CATAGORY3",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 4",
            field: "CATAGORY4",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Kategori 5",
            field: "CATAGORY5",
            sortable: true,
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            columnGroupShow: "open",
            filter: "agSetColumnFilter"
          }
        ]
      },
      {
        headerName: "Fiyat",
        children: [
          {
            width: 120,
            headerName: "Fiyat 1",
            field: "PRICE1",
            sortable: true,
            wrapText: true,
            autoHeight: true,
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 2",
            field: "PRICE2",
            sortable: true,
            columnGroupShow: "open",
            wrapText: true,
            autoHeight: true,
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 3",
            field: "PRICE3",
            sortable: true,
            columnGroupShow: "open",
            type: "rightAligned",
            cellRenderer: "ReceteStokPriceCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Fiyat 4",
            field: "PRICE4",
            sortable: true,
            type: "rightAligned",
            columnGroupShow: "open",
            wrapText: true,
            autoHeight: true,
            cellRenderer: "ReceteStokPriceCellRenderer",
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Döviz",
            field: "CURRCODE",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            sortable: true,
            filter: "agSetColumnFilter"
          }
        ]
      },
      {
        headerName: "Barkod",
        children: [
          {
            width: 100,
            headerName: "Barkod",
            field: "BARCODE",
            sortable: true,
            filter: "agSetColumnFilter",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 1",
            field: "BARCODE1",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agSetColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 2",
            field: "BARCODE2",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 3",
            field: "BARCODE3",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          },
          {
            width: 100,
            headerName: "Barkod 4",
            field: "BARCODE4",
            sortable: true,
            columnGroupShow: "open",
            cellRenderer: "TextGorunumCellRenderer",
            wrapText: true,
            autoHeight: true,
            filter: "agTextColumnFilter"
          }
        ]
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Notlar",
        field: "NOTES",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      },
      {
        headerName: "Reçete Durumu",
        field: "mixAdet",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "ReceteDurumCellRenderer",
        wrapText: true,
        autoHeight: true,
        filterParams: { caseSensitive: true, defaultOption: "startsWith" }
      }
    ];
  }
};
</script>
